import React, { useState, useEffect } from "react";
import axios from "axios";
import * as constants from "../constants/domains";
import qs from "qs";
import { toast } from "react-toastify";
import { useCookies } from "react-cookie";
import VerificationInput from "react-verification-input";
import "./styles.css";
import CountdownTimer from "../components/Counter";
//import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

function PasswordReset(props) {
  const [remaining, setRemaining] = useState(60);
  const [callBack, setCallBack] = useState("");
  const [site, setSite] = useState("");
  const [username, setUsername] = useState("");
  const [inputToken, setInputToken] = useState("");
  const [inputPassword, setInputPassword] = useState("");
  const [validationError, setValidationError] = useState({});
  const [sendVerCodeAgainLoading, setSendVerCodeAgainLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirmTime, setConfirmTime] = useState({});
  const setCookie = useCookies(["user_server_token"])[1];
  const [timer, setTimer] = useState("");
  const [block, setBlock] = useState(false);
  const [ip, setIp] = useState(false);
  const { location, history } = props;
//  const { executeRecaptcha } = useGoogleReCaptcha();

  useEffect(() => {
    const queryParams = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (!queryParams) {
      history.push({
        pathname: "/user",
        search: "?site=shop",
      });
    } else if (!queryParams["token"]) {
      history.push({
        pathname: "/user",
        search: "?site=shop",
      });
    } else {
      try {
        setUsername(window.atob(queryParams["token"]));
        getConfirmTime(window.atob(queryParams["token"]));
      } catch (e) {
        history.push({
          pathname: "/user",
          search: "?site=shop",
        });
      }
      setSite(queryParams["site"] ? queryParams["site"] : "shop");
      setCallBack(queryParams["callBack"] ? queryParams["callBack"] : "");
    }
  }, [history, location]);

  const getConfirmTime = (data) => {
    document.body.style.overflow = "hidden";

    axios
      .post(constants.$apiUrl + "/api/password-reset-confirm-time", {
        username: data,
      })
      .then((response) => {
        document.body.style.overflow = "unset";

        setConfirmTime(response.data.data.confirm_time);

        const remaining =
          response.data.data.confirm_time - Math.floor(Date.now() / 1000);
        if (remaining >= 0) {
          setRemaining(remaining);
        } else {
          setRemaining(0);
        }
      })
      .catch(() => {
        document.body.style.overflow = "unset";
        toast.error(
          "مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
      });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      const remaining = confirmTime - Math.floor(Date.now() / 1000);
      if (remaining >= 0) {
        setRemaining(remaining);
      } else {
        setRemaining(0);
      }
    }, 1000);
    // Clear timeout if the component is unmounted
    return () => clearTimeout(timer);
  });

  const formSubmit = (event) => {
    event.preventDefault();
    let validationErrorVar = {};
    if (inputPassword.toString() === "") {
      validationErrorVar = {
        ...validationErrorVar,
        password: ["پسورد نمیتواند خالی باشد."],
      };
    }
    if (inputToken.toString() === "") {
      validationErrorVar = {
        ...validationErrorVar,
        token: ["توکن نمیتواند خالی باشد."],
      };
    }

    setValidationError({ ...validationErrorVar });

    if (Object.keys(validationErrorVar).length === 0) {
      setLoading(true);
      setValidationError({});

      axios
        .post(constants.$apiUrl + "/api/confirm-password-reset-token", {
          username: username,
          password: inputPassword,
          token: inputToken,
        })
        .then((response) => {
          setLoading(false);

          if (response.data.success) {
            let oneYear = Date.now() + 365 * 24 * 60 * 60 * 1000;

            setCookie("user_server_token", response.data.data.token, {
              domain: constants.$cookieURL,
              path: "/",
              expires: new Date(oneYear),
            });

            const callback = callBack ? callBack : "/";
            if (site === "class") {
              window.location.href = constants.$class_next_url + callback;
            } else {
              window.location.href =
                constants.$shopUrl ;
            }
          } else {
            toast.error(
              "مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید",
              {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              }
            );
          }
        })
        .catch((error) => {
          setLoading(false);
          if (error.response) {
            if (error.response.status === 400) {
              setValidationError({ ...error.response.data.data });
            } else if (error.response.status === 409) {
              setValidationError({
                username: [error.response.data.message],
              });
            } else {
              toast.error(
                "مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید",
                {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                }
              );
            }
          }
        });
    }
  };

  const sendVerCodeAgain = async (event) => {

    event.preventDefault();
//    if (!executeRecaptcha) {
//      alert("کپچا آماده نشده است !");
//      event.stopPropagation();
//      return;
//    }
 //   const tokenRecaptcha = await executeRecaptcha("submit");

    setSendVerCodeAgainLoading(true);

    axios
      .post(constants.$apiUrl + "/api/send-password-reset-token", {
        username: username,
   //     captcha:tokenRecaptcha
      })
      .then((response) => {
        setSendVerCodeAgainLoading(false);
        if (response.data.success) {
          setConfirmTime(response.data.data.confirm_time);
          setRemaining(
            response.data.data.confirm_time - Math.floor(Date.now() / 1000)
          );
        } else {
          toast.error(
            "مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید",
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            }
          );
        }
      })
      .catch((error) => {
        setSendVerCodeAgainLoading(false);
        if (error.response && error.response.status === 400) {
          if (error.response && error.response.data.data == "Limited") {
            if (error.response && error.response.data.limitTime > 0) {
              setTimer(error.response.data.limitTime);
            }
            if (error.response && error.response.data.limitTime == -1) {
              setBlock(true);
              setIp(error.response.data.ip);
            } else {
              setIp(error.response.data.ip);
              setBlock(false);
            }
            toast.error(
              "تعداد درخواست های شما به سرور زیاد شده است لطفا در زمانی دیگر تلاش کنید",
              {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              }
            );
          }

          setValidationError({ ...error.response.data.data });
          if (
            error.response.data.data.username &&
            error.response.data.data.username.length > 0
          ) {
            toast.error(
              "مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید",
              {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              }
            );
          }
        } else {
          toast.error(
            "مشکلی پیش آمد لطفا دوباره تلاش کنید یا با پشتیبانی ارتباط برقرار کنید",
            {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            }
          );
        }
      });
  };

  let minutes = Math.floor((remaining % (60 * 60)) / 60);
  let seconds = Math.floor(remaining % 60);

  return (
    <React.Fragment>
      <div className="container">
        <div className="card-group card-authentication mx-auto mb-5">
          <div className="login-card">
            <div className="card-content direction-rtl">
              <div className="form-header-logo">
                <img
                  src={constants.$authUrl + "/images/honari_logo.png"}
                  alt="هنری دات کام"
                />
                <div className="logo-text">
                  <p className="logo-honari-text">هـنـری</p>
                  <p className="logo-desc-text">تحقق رویای هنرمندانه‌ تو</p>
                </div>
              </div>

              <div className={"form-header"}>تغییر رمز عبور</div>
              <form onSubmit={(event) => formSubmit(event)}>
                <div className="mb-4 row">
                  <label
                    htmlFor="username"
                    className={"register-mobile-message"}
                  >
                    شماره همراه
                  </label>
                  <div className={"login-form-row"}>
                    <input
                      id="username"
                      type="text"
                      disabled={"disabled"}
                      className={"form-field "}
                      value={username}
                    />
                  </div>
                </div>
                <div className="mb-4 row">
                  <label htmlFor="token" className={"register-mobile-message"}>
                    کد بازیابی
                  </label>
                  <div className={"login-form-row"}>
                    <VerificationInput
                      id="token"
                      className={
                        "form-field " +
                        (validationError["token"] &&
                        Array.isArray(validationError["token"])
                          ? "not-valid "
                          : "")
                      }
                      onChange={(event) => setInputToken(event)}
                      value={inputToken}
                      length={4}
                      placeholder=""
                    />
                    {/* <input id="token"
                                               type="text"
                                               className={"form-field " + (validationError['token'] && Array.isArray(validationError['token']) ? 'not-valid ' : '')}
                                               onChange={(event) => setInputToken(event.target.value)}
                                               value={inputToken}
                                        /> */}
                  </div>
                  {validationError["token"] &&
                  Array.isArray(validationError["token"])
                    ? validationError["token"].map((item, index) => {
                        return (
                          <div className={"row"} key={index}>
                            <div key={index} className={"validation-error"}>
                              {item}
                            </div>
                          </div>
                        );
                      })
                    : null}
                </div>

                <div className="mb-4 row">
                  <label htmlFor="email" className={"register-mobile-message"}>
                    رمز عبور جدید
                  </label>
                  <div className={"login-form-row"}>
                    <input
                      id="password"
                      type="password"
                      className={
                        "form-field " +
                        (validationError["password"] &&
                        Array.isArray(validationError["password"])
                          ? "not-valid "
                          : "")
                      }
                      onChange={(event) => setInputPassword(event.target.value)}
                      value={inputPassword}
                    />
                  </div>

                  {validationError["password"] &&
                  Array.isArray(validationError["password"])
                    ? validationError["password"].map((item, index) => {
                        return (
                          <div className={"row"} key={index}>
                            <div key={index} className={"validation-error"}>
                              {item}
                            </div>
                          </div>
                        );
                      })
                    : null}
                </div>
                {timer > 0 && (
                  <div className="mt-3">
                    <span className="pb-4 text-danger">
                      بدلیل درخواست زیاد درخواست شما محدود شده است
                    </span>
                    <div className="mt-2">
                      {" "}
                      <CountdownTimer minutes={timer} />
                    </div>
                  </div>
                )}
                {block && (
                  <span className="pb-4  text-danger">
                    بدلیل درخواست زیاد درخواست شما محدود شده است لطفا با
                    پشتیبانی تماس بگیرید
                    <br />
                    <span>ip : {ip}</span>
                    <br />
                  </span>
                )}
                {remaining > 0 ? (
                  <div className="login-resend-otp-message">
                    ارسال مجدد کد تا{" "}
                    {minutes.toString().length === 1
                      ? "0" + minutes.toString()
                      : minutes.toString()}
                    :
                    {seconds.toString().length === 1
                      ? "0" + seconds.toString()
                      : seconds.toString()}{" "}
                    دیگر
                  </div>
                ) : (
                  <button
                    disabled={sendVerCodeAgainLoading}
                    onClick={sendVerCodeAgain}
                    type="button"
                    className="btn w-100 send-otp-confirm-code"
                  >
                    {sendVerCodeAgainLoading ? (
                      <React.Fragment>در حال ارسال ...</React.Fragment>
                    ) : (
                      <React.Fragment>دریافت مجدد کد تایید</React.Fragment>
                    )}
                  </button>
                )}

                <div className="row">
                  <div className={"my-3"}>
                    {loading ? (
                      <button
                        disabled={true}
                        className="btn btn-honari w-100 py-2"
                      >
                        در حال ارسال اطلاعات...
                      </button>
                    ) : (
                      <button className="btn btn-honari w-100 py-2">
                        ثبت اطلاعات
                      </button>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default PasswordReset;
